import { useSelector } from 'react-redux';

/**
 * Hook to check if a specific credential is currently being probed/verified
 */
export function useCredentialProbeStatus(credentialId: number): boolean {
  const probingId = useSelector((state: any) => state.credentials.probingId);
  return probingId === credentialId;
}
